module.exports = __webpack_public_path__ + "media/src/application/media/person-3-b8c81156e5a29c37fa9208af33a7fbe9.svg";